import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormikContext } from "formik";
import {
  getPostCity,
  getPostRegion,
  getPostDepartment,
} from "../../../http/newPostAPI";
import { deliveryMethodAction } from "../../../store/cart/actions";
import { deliveryMethodSelector } from "../../../store/cart/selectors";
import MySelect from "../../../components/MyForms/MySelect/MySelect"; // Використання оновленого MySelect
import { getAddresses } from "../../../http/addressAPI";
import styles from "./DeliveryDataInputs.module.scss";

  const pickupPoint = [
    {value: "м. Кременчук, вул. Соборна 16|9, Будинок Торгівлі, 2 поверх", label: "м. Кременчук, вул. Соборна 16|9, Будинок Торгівлі, 2 поверх"}
  ]
  const regionsOptions = [
    {value: "71508137-9b87-11de-822f-000c2965ae0e", label: "Полтавська" }
  ]
  const citiesOptions = [
    {value: "8d5a9813-391c-11dd-90d9-001a92567626", label: "Кременчук" }]
    
const DeliveryDataInputs = () => {
  const { values, setFieldValue } = useFormikContext();
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [departments, setDepartments] = useState([]);
  const dispatch = useDispatch();
  const [pickupPoints, setPickupPoints] = useState(pickupPoint);
  const deliveryMethod = useSelector(deliveryMethodSelector);

  useEffect(() => {
    getAddresses().then((res) => {
      console.log("address", res);

      if (res?.data?.data.length) {
      console.log("address", res);

        const data = res.data.data
        setPickupPoints(
            data.map((address) => ({
              value: address.name + '|' + address.address,
              label: address.name + '|' + address.address,
            }))
          );
      }
    })
  }, []);

  // Завантаження регіонів
  useEffect(() => {
    getPostRegion()
      .then((res) => {
        if (res?.data?.length) {
          setRegions(
            res.data.map((region) => ({
              value: region.Ref,
              label: region.Description,
            }))
          );
        } else {
          console.error("Regions data is empty:", res);
        }
      })
      .catch((error) => console.error("Error fetching regions:", error));
  }, []);

  // Автоматичне оновлення міст при виборі області
  useEffect(() => {
    if (values.region) {
      setCities([]);
      setDepartments([]);
      setFieldValue("city", "");
      setFieldValue("address", "");

      getPostCity(values.region.value)
        .then((res) => {
          if (res?.data?.length) {
            setCities(
              res.data.map((city) => ({
                value: city.Ref,
                label: city.Description,
              }))
            );
          } else {
            console.warn("No cities received for region:", values.region.label);
          }
        })
        .catch((error) => console.error("Error fetching cities:", error));
    }
  }, [values.region]);

  // Автоматичне оновлення відділень при виборі міста
  useEffect(() => {
    if (values.city) {
      setDepartments([]);
      setFieldValue("address", "");

      getPostDepartment(values.city.value)
        .then((res) => {
          if (res?.data?.length) {
            setDepartments(
              res.data.map((dep) => ({
                value: dep.Ref,
                label: dep.Description,
              }))
            );
          } else {
            console.warn("No departments received for city:", values.city.label);
          }
        })
        .catch((error) => console.error("Error fetching departments:", error));
    }
  }, [values.city]);
useEffect(() => {
console.log("Delivery method changed:", values);
}, [values])

  useEffect(() => {
    if (values.delivery.label === "Самовивіз") {
      setFieldValue("region", regionsOptions[0]);
    }
  }, [values.delivery]);

    useEffect(() => {
    if (values.delivery.label === "Самовивіз") {
      setFieldValue("city", citiesOptions[0]);
    }
  }, [values.region]);
  return (
    <div>
      {/* Вибір способу доставки */}
      <MySelect
        label="Спосіб доставки"
        name="delivery"
        options={[
          { value: "Нова пошта", label: "Нова пошта" },
          { value: "Самовивіз", label: "Самовивіз" },
        ]}
        onChange={(selectedOption) => {
          dispatch(deliveryMethodAction(selectedOption.value));
          setFieldValue("delivery", selectedOption.value);
          // Скидаємо інші поля, якщо перемикають спосіб доставки
          setFieldValue("region", "");
          setFieldValue("city", "");
          setFieldValue("address", "");
        }}
      />
      { values.delivery.label === "Нова пошта" && ( 
        <>
          {/* Вибір області */}
          <MySelect
            label="Область"
            name="region"
            options={regions}
            onChange={(selectedOption) => setFieldValue("region", selectedOption)}
          />

          {/* Вибір міста */}
          <MySelect
            label="Місто"
            name="city"
            options={cities}
            isDisabled={!values.region}
            onChange={(selectedOption) => setFieldValue("city", selectedOption)}
          />

          {/* Вибір відділення */}
          <MySelect
            label="Відділення"
            name="address"
            options={departments}
            isDisabled={!values.city}
            onChange={(selectedOption) => setFieldValue("address", selectedOption)}
          />
        </>
      )}
      {values.delivery.label === "Самовивіз" && (
        <>
          <MySelect 
            label="Адреса самовивозу"
            name="address"
            options={pickupPoints}
            onChange={(selectedOption) => {
              setFieldValue("address", selectedOption)
            }}
          />
        </>
      )}
    </div>
  );
};

export default DeliveryDataInputs;
